import { createFileRoute } from "@tanstack/react-router";
import CustomerRewards from "@/pages/customer/CustomerRewards";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/my-account/rewards")({
  head: () => { const h = pageHead({ title: 'Rex & Sons RVs', description: 'Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.', path: '/my-account/rewards' }); h.meta.push({ name: "robots", content: "noindex, follow" }); return h; },
  component: CustomerRewards,
});
